module.exports = __webpack_public_path__ + "img/icon0.768f221d.png";